import React, { FC, useState, useEffect } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { Box, DialogTitle } from "@material-ui/core";
import { SelectItemInterface } from "../../../interface/SelectItemInterface";
import { MyDialog } from "../../Ui/MyDialog";
import CustomSelect from "../../Ui/CustomSelect";
import { CustomButton } from "../../Ui/CustomButton";

interface LeaderModalProps {
  personItems: Array<SelectItemInterface>;
  isLeader: boolean;
  handleClose(): void;
  handleChangeLeader(leaderId: string): void;
}

const LeaderModal: FC<LeaderModalProps & WrappedComponentProps> = (props) => {
  const {
    intl,
    isLeader,
    personItems,
    handleClose,
    handleChangeLeader: _changeLeader,
  } = props;
  const [leader, setLeader] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  useEffect(() => {
    if (isLeader) {
      setLeader("");
      setIsSubmitted(false);
    }
  }, [isLeader]);

  const handleSelectLeader = (name: string, value: string) => {
    setLeader(value);
  };
  const handleChangeLeader = () => {
    setIsSubmitted(true);
    if (!leader) {
      return null;
    }
    _changeLeader(leader);
  };
  return (
    <MyDialog
      open={isLeader}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      dialogTitle={
        <DialogTitle>
          {intl.formatMessage({ id: "stepFive.modal.title" })}
        </DialogTitle>
      }
      closable={false}
      disableBackdropClick
      disableEscapeKeyDown // disable escape key
    >
      <Box>
        <CustomSelect
          setValue={handleSelectLeader}
          options={personItems}
          name="title"
          value={leader}
          isSubmitted={isSubmitted}
        />
        <CustomButton
          type="button"
          variant="primary"
          onClick={handleChangeLeader}
          label="save"
          fullWidth
        />
      </Box>
    </MyDialog>
  );
};

export default injectIntl(LeaderModal);
